import React from "react";
import PropTypes from "prop-types";
import { InputText, Label, Dropdown } from "../../../../components/Inputs";
import DelphiConnectionListForm from "./DelphiConnectionListForm";
import {
  STATUS_LABELS,
  statusIsEditable,
  STATUS_IDS,
  ACTION_IDS,
  IDTag,
  isSet,
} from "../../../../components/Utils";
import { PrimaryButton, SecondaryButton } from "../../../../components/Buttons";
import ConfirmationDialog from "../../../../components/ConfirmationDialog";
import {
  PermissionResource,
  PermissionSection,
  Resources,
} from "../../../Permissions";
import ADConnectionListForm from "./ADConnectionListForm";
import ANPConnectionListForm from "./ANPConnectionListForm";
import JarvisConnectionListForm from "./JarvisConnectionListForm";
import NGUMStatusObserver from "../../../NGum/containers/NGUMStatusObserver";

const YesNoOptions = [
  { label: "Ja", value: "Ja" },
  { label: "Nein", value: "Nein" },
];

export default class ITConnectionForm extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    model: PropTypes.shape({}),
    kdlCompanyList: PropTypes.array,
    userCompany: PropTypes.object,
    canReadAdminData: PropTypes.bool,
    rows: PropTypes.number,
    vfEmailPermission: PropTypes.shape({}),
    ngumUserIdPermission: PropTypes.shape({}),
    getCompanyData: PropTypes.func.isRequired,
    getEmployeeData: PropTypes.func.isRequired,
    roleList: PropTypes.array.isRequired,
    userDisabled: PropTypes.bool,
    isDL: PropTypes.bool,
  };
  static defaultProps = {
    className: "",
    model: {
      ptConnection: "",
      ptUsername: "",
      ptPassword: "",
      adConnection: "",
      adUsername: "",
      adPassword: "",
      adCellNumber: "",
      anpConnection: {},
      delphiConnections: [],
      jarvisConnection: null,
    },
    companyList: [],
    kdlCompanyList: [],
    rows: 5,
    isDL: false,
  };
  constructor(props) {
    super(props);
    const model = props.model || {};
    const defaultStatusId = STATUS_IDS.NEW;
    const adStatus_id =
      model.adStatus_id && model.adStatus_id !== ""
        ? model.adStatus_id
        : defaultStatusId;
    const ptStatus_id =
      model.ptStatus_id && model.ptStatus_id !== ""
        ? model.ptStatus_id
        : defaultStatusId;
    this.state = {
      adConnection: model.adConnection || "",
      adStatus_id,
      ptConnection: model.ptConnection || "",
      ptUsername: model.ptUsername || "",
      ptPassword: model.ptPassword || "",
      ptAction_id: model.ptAction_id || "",
      ptStatus_id,
      ptStatus: model.ptStatus || STATUS_LABELS[ptStatus_id],
      error: {
        ptConnection: null,
      },
    };
  }
  validate = () => {
    let model = {};
    // vodafone account
    const adModel = this.adConnection.getModel();
    if (!adModel) {
      return null;
    }
    model = { ...model, ...adModel };
    // anp account
    model.anpConnection = !this.anpConnection
      ? {}
      : this.anpConnection.getModel();
    // pt connection
    const { error, adConnection, adStatus_id, ...ptModel } = this.state;
    // const ptModel = this.ptConnection.getModel();
    model = { ...model, ...ptModel };
    // delphi connections
    const connections = !this.connections ? [] : this.connections.getModel();
    model.delphiConnections = connections;
    // jarvis connection
    model.jarvisConnection = !this.jarvisConnection
      ? null
      : this.jarvisConnection.getModel();

    const pModel = this.props.model || {};
    const { id, ad_id, pt_id } = pModel;
    model.id = id;
    model.ad_id = ad_id;
    model.pt_id = pt_id;
    return model;
  };
  getModel = () => {
    const model = this.validate();
    return model;
  };
  executeChange = (connectionType, actionId, statusId) => {
    const prefix = connectionType.toLowerCase();
    this.setState({
      [`${prefix}Action_id`]: actionId,
      [`${prefix}Status_id`]: statusId,
      [`${prefix}Status`]: STATUS_LABELS[statusId],
    });
  };
  onChange = (connectionType) => {
    const title = `${connectionType}-Zugang ändern`;
    const text = `Wollen Sie eine Verlängerung des ${connectionType}-Zugangs wirklich beantragen?`;
    const execFunc = () =>
      this.executeChange(
        connectionType,
        ACTION_IDS.UPDATE,
        STATUS_IDS.UPDATING,
      );
    this.confirm.show(true, { title, text }, execFunc);
  };
  onDelete = (connectionType) => {
    const title = `${connectionType}-Zugang löschen`;
    const text = `Wollen Sie eine Löschung des ${connectionType}-Zugangs wirklich beantragen?`;
    const execFunc = () =>
      this.executeChange(
        connectionType,
        ACTION_IDS.DELETE,
        STATUS_IDS.DELETING,
      );
    this.confirm.show(true, { title, text }, execFunc);
  };
  onADConnectionChange = (adConnection, adStatus_id) => {
    this.setState({ adConnection, adStatus_id });
  };
  renderConnectionBtns = (connectionType, model) => {
    const idAttr = `${connectionType.toLowerCase()}_id`;
    const statusAttr = `${connectionType.toLowerCase()}Status_id`;
    return (
      <div>
        {connectionType !== "AD" && (
          <PrimaryButton
            size="small"
            disabled={!statusIsEditable(model[statusAttr], model[idAttr])}
            onClick={() => this.onChange(connectionType)}
          >
            {`Ändern`}
          </PrimaryButton>
        )}
        <SecondaryButton
          className="margin-top"
          size="small"
          disabled={!statusIsEditable(model[statusAttr], model[idAttr])}
          onClick={() => this.onDelete(connectionType)}
        >
          {`Löschen`}
        </SecondaryButton>
      </div>
    );
  };
  render() {
    const {
      className,
      userCompany,
      kdlCompanyList,
      canReadAdminData,
      model,
      rows,
      vfEmailPermission,
      ngumUserIdPermission,
      userDisabled,
    } = this.props;
    const { ptConnection, ptUsername, ptPassword, ptStatus, ptStatus_id } =
      this.state;
    const adConnection = model.adConnection || this.state.adConnection || "";
    // flag to check the status of the underlying vodafone account. It ensures that:
    // 1. vodafone account exists
    // 2. vodafone account status is NEU, IN BEARBEITUNG oder ABGESCHLOSSEN
    const isVodafoneAccountPresent =
      adConnection.toLowerCase() === "ja" && (
        this.state.adStatus_id === STATUS_IDS.NEW ||
        this.state.adStatus_id === STATUS_IDS.PROCESSING ||
        this.state.adStatus_id === STATUS_IDS.FINISHED
      );
    // && (isSet(model.vf_email) && model.vf_email.length != "");
    console.log(
      "ITConnectionForm",
      model,
      "isVodafoneAccountPresent:",
      isVodafoneAccountPresent,
      userDisabled,
    );
    return (
      <div className={className}>
        <PermissionResource
          resource={Resources.Organisation.WorkerWizard.ADConnections}
        >
          <PermissionSection
            height="auto"
            id="vodafone-account"
            className="neg-margin-big-lr pad-big-lr pad-big-btm"
            isUnterWizardTitle
            idOffset={-164}
          >
            <ADConnectionListForm
              ref={(ref) => (this.adConnection = ref)}
              className="pad-big-top"
              model={model}
              vfEmailPermission={vfEmailPermission}
              ngumUserIdPermission={ngumUserIdPermission}
              onChange={this.onADConnectionChange}
              readOnly={userDisabled}
            />
          </PermissionSection>
        </PermissionResource>
        <PermissionResource
          resource={Resources.Organisation.WorkerWizard.ANPAccount}
        >
          <PermissionSection
            height="auto"
            id="anp-zugang"
            className="w3-border-top neg-margin-big-lr pad-big-lr pad-big-btm"
            isUnterWizardTitle
            idOffset={-164}
          >
            <NGUMStatusObserver>
              <ANPConnectionListForm
                ref={(ref) => (this.anpConnection = ref)}
                className="pad-big-top"
                model={model.anpConnection}
                getCompanyData={this.props.getCompanyData}
                roleList={this.props.roleList}
                isVodafoneAccountPresent={isVodafoneAccountPresent}
                readOnly={!isVodafoneAccountPresent || userDisabled}
              />
            </NGUMStatusObserver>
          </PermissionSection>
        </PermissionResource>
        <PermissionResource
          resource={Resources.Organisation.WorkerWizard.PTConnections}
        >
          <PermissionSection
            height="auto"
            id="iprov-zugang"
            className="w3-border-top neg-margin-big-lr pad-big-lr pad-big-btm"
            isUnterWizardTitle
            idOffset={-164}
          >
            <PTConnectionForm
              model={model}
              adConnection={adConnection}
              ptConnection={ptConnection}
              ptUsername={ptUsername}
              ptPassword={ptPassword}
              ptStatus={ptStatus}
              ptStatus_id={ptStatus_id}
              setState={(...args) => this.setState(...args)}
              renderConnectionBtns={this.renderConnectionBtns}
              children={this.props.children}
              disabled={
                !isVodafoneAccountPresent ||
                !statusIsEditable(ptStatus_id, model.pt_id, true) ||
                userDisabled
              }
            />
          </PermissionSection>
        </PermissionResource>
        <PermissionResource
          resource={Resources.Organisation.WorkerWizard.DelphiConnections}
        >
          <PermissionSection
            height="auto"
            id="delphi-zugaenge"
            className="w3-border-top neg-margin-big-lr pad-big-lr pad-big-btm"
            isUnterWizardTitle
            idOffset={-164}
          >
            <DelphiConnectionListForm
              ref={(ref) => (this.connections = ref)}
              className="pad-big-top"
              model={model.delphiConnections}
              kdlCompanyList={kdlCompanyList}
              userCompany={userCompany}
              disableDelphi={!isVodafoneAccountPresent || userDisabled}
              canReadAdminData={canReadAdminData}
              rows={rows}
            />
          </PermissionSection>
        </PermissionResource>
        <PermissionResource
          resource={Resources.Organisation.WorkerWizard.JarvisConnection}
        >
          <PermissionSection
            height="auto"
            id="jarvis-zugang"
            className="w3-border-top neg-margin-big-lr pad-big-lr pad-big-btm"
            isUnterWizardTitle
            idOffset={-162}
          >
            <JarvisConnectionListForm
              ref={(ref) => (this.jarvisConnection = ref)}
              className="pad-big-top"
              model={model.jarvisConnection}
              kdlCompanyList={kdlCompanyList}
              getCompanyData={this.props.getCompanyData}
              getEmployeeData={this.props.getEmployeeData}
              readOnly={!isVodafoneAccountPresent || userDisabled} // disable until vodafone account is completed
              canReadAdminData={canReadAdminData}
              isDL={this.props.isDL}
            />
          </PermissionSection>
        </PermissionResource>
        <ConfirmationDialog ref={(ref) => (this.confirm = ref)} />
      </div>
    );
  }
}

const PTConnectionForm = ({
  model,
  adConnection,
  ptConnection,
  ptUsername,
  ptPassword,
  ptStatus,
  ptStatus_id,
  setState,
  renderConnectionBtns,
  readOnly,
  disabled: _disabled,
}) => {
  const disabled =
    _disabled || !statusIsEditable(ptStatus_id, model.pt_id, true);
  return (
    <>
      {/* <div className="w3-border-top neg-margin-big-lr margin-big-top margin-btm" /> */}
      <div className="pad-big-top w3-cell-row">
        <div className="w3-cell w3-cell-top">
          <div className="w3-row neg-margin-lr">
            <div className="w3-col s2 pad-lr pad-top">
              <Label htmlFor="ptConnection">{`Prov.-tool-Zugang*`}</Label>
              <Dropdown
                id="ptConnection"
                className="w3-block w3-border"
                value={ptConnection}
                placeholder="Bitte auswählen"
                disabled={
                  disabled ||
                  adConnection !== "Ja" ||
                  ptStatus_id !== STATUS_IDS.NEW
                }
                options={YesNoOptions}
                onChange={(event) => setState({ ptConnection: event.value })}
                showClear
              />
            </div>
            <div className="w3-col s8 pad-lr">
              <div className="w3-row neg-margin-lr">
                <div className="w3-col s4 pad-lr pad-top">
                  <Label htmlFor="ptUsername">{`Prov.-tool-Kennung`}</Label>
                  <InputText
                    id="ptUsername"
                    className="w3-block w3-border pad round-input"
                    value={ptUsername}
                    readonly
                  />
                </div>
                <PermissionResource
                  resource={
                    Resources.Organisation.WorkerWizard.ConnectionPasswords
                  }
                >
                  <div className="w3-col s4 pad-lr pad-top">
                    <Label htmlFor="ptPassword">{`Prov.-tool-Passwort`}</Label>
                    <InputText
                      id="ptPassword"
                      className="w3-block w3-border pad round-input"
                      value={ptPassword}
                      readonly
                    />
                  </div>
                </PermissionResource>
              </div>
            </div>
            <div className="w3-col s2 pad-lr pad-top">
              <Label htmlFor="ptStatus">{`PT-Zugangstatus`}</Label>
              <InputText
                id="ptStatus"
                className="w3-block w3-border pad round-input"
                value={ptStatus}
                readonly
              />
            </div>
          </div>
        </div>
        {!_disabled && !readOnly && (
          <div
            className="w3-cell w3-cell-bottom alg-rht"
            style={{ width: "150px" }}
          >
            {renderConnectionBtns("PT", { ...model, ptStatus_id })}
          </div>
        )}
      </div>
    </>
  );
};
